import styled from 'styled-components';

export const StyledMatrixModelContainer = styled.div`
  margin-top: var(--cl-space-3);
`;
